<form *ngIf="formGroup" [formGroup]="formGroup" (submit)="submit()">

    <div class="group flex">

        <mat-form-field class="full">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" required>
        </mat-form-field>

        <div class="full" *ngIf="formGroup.get('description')">
            <common-form-editor label="Description" [value]="editorInitialValue"
                                (valueChange)="formGroup.get('description').setValue($event)"></common-form-editor>
        </div>

        <div class="full">
            <button type="button" mat-raised-button class="full margin-bottom-10" (click)="uploadFile()">
                Upload a file
            </button>
        </div>

        <div class="full">
            <ng-template ngFor let-file let-index="index" [ngForOf]="uploadedFile">
                <div class="attachment" [matTooltip]="file.name"
                     [ngStyle]="{ 'background-image': (file.url.includes('.jpeg') ? 'url('+file.url+')' : '/assets/images/logo-semi-transparent.png') }">
                    <mat-icon class="delete" matTooltip="Delete" (click)="deleteFile(index)" color="warn">
                        delete
                    </mat-icon>
                    <div class="title">
                        {{ file.name }}
                    </div>
                </div>
            </ng-template>
        </div>


        <mat-form-field class="third">
            <mat-label>Kind</mat-label>
            <mat-select formControlName="request_kind_id" required>
                <mat-option *ngFor="let kind of kinds" [value]="kind.value">
                    {{ kind.name }}
                </mat-option>
            </mat-select>
            <span matPrefix><mat-icon>ballot</mat-icon>&nbsp;</span>
        </mat-form-field>


        <div class="half" *ngIf="showOrderLink">
            <mat-checkbox [checked]="true" [disabled]="true">Link to this order</mat-checkbox>
        </div>
        <div class="full" *ngIf="!showOrderLink">
            <common-form-search
                    url="/order"
                    [value]="formGroup.value.order_id"
                    label="Link order"
                    (valueChange)="formGroup.get('order_id').setValue($event)"
            ></common-form-search>
        </div>


        <mat-form-field class="half" *ngIf="showRelatedPartners">
            <mat-label>Related partner</mat-label>
            <mat-select formControlName="related_partner" required>
                <mat-option *ngFor="let partner of partners" [value]="partner.value">
                    {{ partner.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </div>


    <div class="actions flex row space-between">
        <button mat-raised-button color="primary" type="submit" class="main" [disabled]="!formGroup.valid">
            Submit
        </button>
        &nbsp;
        &nbsp;
        <div>
            <button mat-button type="button" (click)="close()">Cancel</button>
            <button mat-button type="button" (click)="minimize()">Minimize</button>
        </div>

    </div>

</form>